'use client';

import React__default from 'react';
import Typography from '../../Typography/index.js';
import { colors } from '../../Colors/index.js';

var Title = function (_a) {
    var title = _a.title, subTitle = _a.subTitle;
    return (React__default.createElement(Typography, { variant: 'h2', style: { textAlign: 'center', padding: '24px 0 ' } },
        React__default.createElement(Typography, { variant: 'p', name: 'headline', size: 'large', style: { marginBottom: 8 } }, title),
        React__default.createElement(Typography, { variant: 'p', name: 'body', size: 'large', color: colors.grey[50] }, subTitle)));
};

export { Title };
//# sourceMappingURL=Title.js.map
